/**
 * RouteSkeleton — shared Suspense fallback for lazily-loaded routes. Renders
 * inside AppShell (the shell stays eager), reserving height so navigation never
 * blanks or shifts layout while the route chunk loads.
 */
export function RouteSkeleton() {
  return <div className="skeleton" style={{ height: 420, borderRadius: 'var(--radius-md)' }} aria-label="Loading page" />;
}
